class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      // Fehlt eines der Ziele im DOM, brach bisher die gesamte Schleife ab und
      // das Popup blieb leer. Lieber das eine Fragment ueberspringen.
      const target = document.getElementById(section.id);
      if (!target) return;

      target.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section || section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    const sectionId = this.dataset.sectionId || this.notification?.dataset.sectionId;

    return [
      {
        id: 'cart-notification-product',
        section: sectionId,
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      // Ohne selector greift der Standard '.shopify-section'. Die Sections
      // cart-notification-button und cart-icon-bubble rendern nur den Inhalt
      // der Zielelemente, sie enthalten selbst kein #cart-notification-button
      // bzw. #cart-icon-bubble - mit diesen Selektoren fand DOMParser nichts
      // und renderContents hat die Ziele geleert (Warenkorb-Symbol im Header
      // verschwand nach dem Hinzufuegen bis zum naechsten Seitenaufruf).
      {
        id: 'cart-notification-button',
        section: sectionId,
      },
      {
        id: 'cart-notification-shipping',
        section: sectionId,
      },
      {
        id: 'cart-icon-bubble',
        section: sectionId,
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) {
      console.warn(`CartNotification: Kein HTML für den Abschnitt mit Selektor “${selector}” erhalten.`);
      return '';
    }

    const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);

    if (!parsed) {
      console.warn(`CartNotification: Das Element mit Selektor “${selector}” wurde nicht gefunden.`);
      return '';
    }

    return parsed.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);